var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisabledCheckboxSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 2.5,
    fill: "#DBDBDB",
    stroke: "#808285"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.331 6.33103C16.6483 6.64833 16.671 7.1487 16.399 7.49215L16.331 7.56847L8.90641 14.9931C8.58911 15.3104 8.08874 15.3331 7.74529 15.0611L7.66897 14.9931L3.95666 11.2808C3.61495 10.9391 3.61495 10.385 3.95666 10.0433C4.27396 9.72604 4.77433 9.70338 5.11778 9.97535L5.1941 10.0433L8.28811 13.1365L15.0936 6.33103C15.4109 6.01373 15.9113 5.99106 16.2547 6.26304L16.331 6.33103Z",
    fill: "#808285"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisabledCheckboxSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DisabledCheckboxSelected.9be1e91c8e0c23b9739c1d723bce4d53.svg";